// removed by extract-text-webpack-plugin
module.exports = {"form_wrapper":"_2bkvI","form_name":"OIvHa","form_select":"_3wKte","form_select_dropdown":"X29ze","form_input":"_3ugNl","form_btn_wrapper":"_2WZn1","form_collapse":"_1hsmL","button":"_3-lFc","btn_primary":"_2fczk _3-lFc _2fczk _3-lFc","btn_secondary":"_3cJZu _3-lFc","btn_warning":"_2sawf _3cJZu _3-lFc _2sawf _3cJZu _3-lFc","root":"_3VTmR","form":"WvHAc","sms_select":"_2QA0b _3meWM","btn_wrapper":"_2-jMI","input_wrapper":"_3SNSQ _2bkvI","input_name":"_3BZt2 _1I1NP","text_input":"_2H7aO _3ugNl","button_wrapper":"_239IJ _2WZn1"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/contacts/NewUser.css
// module id = 732
// module chunks = 0